import { ContentWrapper } from "@gtsanders/Overrides/Widgets/Basic/RichContent";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { RichContent } from "@insite/content-library/Widgets/Basic/RichContent";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import  { PageProps as MobiusPageProps } from "@insite/mobius/Page";
const enum fields {
    showPromoBannerToggle = "showPromoBannerToggle",
    promoBannerRichContent = "promoBannerRichContent",
    promoBannerBackgroundColor = "promoBannerBackgroundColor",
    promoBannerPadding = "promoBannerPadding"
}
interface Props extends WidgetProps {
    fields: {
        [fields.showPromoBannerToggle]: boolean;
        [fields.promoBannerRichContent]: string;
        [fields.promoBannerBackgroundColor]: string;
        [fields.promoBannerPadding]: number;
    };
}
export interface PromoBannerStyles {
    promoWrapper?: InjectableCss;
}

export const PromoBannerStyles: PromoBannerStyles = {
    promoWrapper: {
        css: css`
    
        `
    },
}

const styles = PromoBannerStyles;
const PromoBanner: React.FunctionComponent<Props> = props => {
    if (!props.fields.promoBannerRichContent) {
        return null;
    }
    return (
    <StyledWrapper {...styles.promoWrapper}>
        {props.fields.showPromoBannerToggle && (
            
                 <ContentWrapper
                     className="promoWrapper"
                     backgroundColor={props.fields.promoBannerBackgroundColor}
                     padding={props.fields.promoBannerPadding}
                 >
                     <StyledWrapper>
                        {parse(props.fields.promoBannerRichContent, parserOptions)}
                     </StyledWrapper>
                 </ContentWrapper>
            

         )}
    </StyledWrapper>
    );
};


const widgetModule: WidgetModule = {
    component: PromoBanner,
    definition: {
        displayName: "Promo Banner",
        group: "Basic",
        icon: "diamond",
        fieldDefinitions: [
            {
                name: fields.showPromoBannerToggle,
                displayName: "Show/Hide Promo Banner Toggle",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.promoBannerRichContent,
                displayName: "Promo Banner Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                fieldType: "General",
                name: fields.promoBannerBackgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Promo Banner Background Color",
                defaultValue: "",
            },
            {
                fieldType: "General",
                name: fields.promoBannerPadding,
                editorTemplate: "IntegerField",
                displayName: "Promo Banner Content Padding",
                defaultValue: 0,
            },
        ],
    },
};

export default widgetModule;
